import { Truck, Zap, Heart, Award, Building2, CalendarCheck, Shield, Maximize } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_7a187c08-1566-4a5d-94a6-902036d37fa8/artifacts/oin9oc2t_Untitled%20design%20%2814%29.png";

const reasons = [
  { icon: Truck, title: 'Free Pickup & Delivery', desc: 'Right to your door at no extra cost.' },
  { icon: Zap, title: 'Fast Turnaround', desc: 'Same-day and next-day service available.' },
  { icon: Heart, title: 'Friendly Local Service', desc: 'Family-owned since 1963.' },
  { icon: Award, title: 'Quality Garment Care', desc: 'Pre-treat stains, handle with care.' },
  { icon: Building2, title: 'Commercial Accounts', desc: 'Customized plans for businesses.' },
  { icon: CalendarCheck, title: 'Convenient Scheduling', desc: 'Flexible recurring pickups.' },
  { icon: Shield, title: 'Trusted & Established', desc: '60+ years serving the community.' },
  { icon: Maximize, title: 'Large Capacity Machines', desc: 'Comforters, blankets, bulky loads.' },
];

export default function WhyChooseUs() {
  return (
    <section className="py-24 md:py-32 bg-poly-bg relative overflow-hidden" data-testid="why-choose-section">
      {/* Logo watermark */}
      <img src={LOGO_URL} alt="" className="logo-watermark absolute -left-16 top-1/2 -translate-y-1/2 w-64 h-64" aria-hidden="true" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16 reveal">
          <div className="flex items-center justify-center gap-3 mb-3">
            <div className="bg-white rounded-full p-1 shadow-md ring-1 ring-slate-100">
              <img src={LOGO_URL} alt="Poly Clean Center" className="w-8 h-8 object-contain" />
            </div>
            <span className="text-poly-orange font-semibold text-sm tracking-wider uppercase">Why Poly Clean Center</span>
          </div>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-poly-blue-dark tracking-tight mb-4">
            The Laundry Service{' '}
            <span className="text-poly-blue">You Can Count On</span>
          </h2>
        </div>

        {/* Benefits Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {reasons.map((item, i) => (
            <div
              key={i}
              className={`feature-item bg-white rounded-2xl p-6 border border-slate-100 group reveal reveal-delay-${Math.min(i + 1, 5)}`}
              data-testid={`why-item-${i}`}
            >
              <div className="w-11 h-11 rounded-xl bg-sky-50 flex items-center justify-center mb-4 group-hover:bg-poly-blue group-hover:text-white transition-colors duration-300">
                <item.icon className="w-5 h-5 text-poly-blue group-hover:text-white transition-colors duration-300" />
              </div>
              <h3 className="font-heading font-bold text-base text-poly-blue-dark mb-1">{item.title}</h3>
              <p className="text-poly-muted text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
